import './style.css'

export default class StaticPage {
    static selector = '.page'

    constructor(block) {
        this.block = block;
    }
}
